import type Address from '~/types/Address';
import type Manifest from '~/types/Manifests';

import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';
import { type ManifestsDateRangeByAddress } from '~/types/Manifests';
import { getFailed, getNotRequested, getRequesting, getSuccess } from '~/utils/fetchable';

export type ManifestMap = Readonly<Record<string, Manifest>>;

export type ManifestsState = {
  readonly addresses: readonly Address[];
  readonly createManifestErrors: readonly string[];
  readonly downloadingDocumentsManifestID?: number;
  readonly isCreateLoading: boolean;
  readonly manifestGroups: Requestable<Readonly<ManifestsDateRangeByAddress>, Error>;
  readonly manifests: Requestable<ManifestMap, Error>;
  readonly selectedAddress: string;
  readonly selectedCarrier: string;
};

export const initialState: ManifestsState = {
  addresses: [],
  createManifestErrors: [],
  downloadingDocumentsManifestID: undefined,
  isCreateLoading: false,
  manifestGroups: getNotRequested(),
  manifests: getNotRequested(),
  selectedAddress: '',
  selectedCarrier: '',
};

const manifests = (state: ManifestsState = initialState, action: ActionTypes): ManifestsState => {
  switch (action.type) {
    case ActionKeys.MANIFESTS_FETCH:
      return {
        ...state,
        manifests: getRequesting(),
      };
    case ActionKeys.MANIFESTS_FETCH_SUCCESS:
      const manifestsMap = action.payload.reduce((hashMap: Record<string, Manifest>, manifest) => {
        hashMap[manifest.objectId] = manifest;
        return hashMap;
      }, {});
      return {
        ...state,
        manifests: getSuccess(manifestsMap),
      };
    case ActionKeys.MANIFESTS_FETCH_SUCCESS_TERMINAL_STATE:
      if (state.manifests.kind === 'success') {
        const manifestsCopy = { ...state.manifests.data };
        for (const manifest of action.payload) manifestsCopy[manifest.objectId] = manifest;

        return {
          ...state,
          manifests: getSuccess(manifestsCopy),
        };
      }
      return state;
    case ActionKeys.MANIFESTS_DOWNLOAD_ZIP:
      return {
        ...state,
        downloadingDocumentsManifestID: action.payload,
      };
    case ActionKeys.MANIFESTS_DOWNLOAD_ZIP_SUCCESS:
    case ActionKeys.MANIFESTS_DOWNLOAD_ZIP_ERROR:
      return {
        ...state,
        downloadingDocumentsManifestID: undefined,
      };
    case ActionKeys.MANIFESTS_FETCH_ERROR:
      return {
        ...state,
        manifests: getFailed(action.payload),
      };
    case ActionKeys.MANIFESTS_GROUPS_FETCH:
      return {
        ...state,
        manifestGroups: getRequesting(),
        selectedCarrier: action.payload.carrierObjectId,
      };
    case ActionKeys.MANIFESTS_UPDATE_ADDRESS:
      return {
        ...state,
        selectedAddress: action.payload.address,
      };
    case ActionKeys.MANIFESTS_GROUPS_FETCH_SUCCESS:
      return {
        ...state,
        addresses: action.payload.addresses,
        manifestGroups: getSuccess(action.payload.ranges),
      };
    case ActionKeys.MANIFESTS_GROUPS_FETCH_ERROR:
      return {
        ...state,
        manifestGroups: getFailed(action.payload),
      };
    case ActionKeys.MANIFESTS_GENERATE:
      return {
        ...state,
        createManifestErrors: [],
        isCreateLoading: true,
      };
    case ActionKeys.MANIFESTS_GENERATE_SUCCESS:
      return {
        ...state,
        createManifestErrors: [],
        isCreateLoading: false,
      };
    case ActionKeys.MANIFESTS_GENERATE_ERROR:
      return {
        ...state,
        createManifestErrors: [...state.createManifestErrors, action.payload.message],
        isCreateLoading: false,
      };
    case ActionKeys.MANIFESTS_POLL_START:
      return {
        ...state,
      };
    case ActionKeys.MANIFESTS_POLL_END:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default manifests;
